import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as RolesActions } from 'store/ducks/roles';

import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Configs/Roles/components';

class Create extends Component {
  state = {
    form: {
      title: '',
      alias: '',
      description: '',
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Configurações', to: '/configs' },
      { name: 'Permissões', to: '/configs/roles' },
      { name: 'Novo', to: '' },
    ],
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;

    this.props.createRoleRequest({ ...form });
  };

  render() {
    const { form, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={form} saving={create.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.roles.create,
});

const mapActions = dispatch => bindActionCreators(RolesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Create);
